<template>
  <div class="footFlex">
    <div class="bg-img">
      <div class="logoimg">
        <div class="logo-top">
          <div class="j-img"><img src="../../assets/research/产品bg.png" alt=""></div>
          <div>
            <div><img class="logo-i" src="../../assets/laboratory/Logo.png" alt=""></div>
            <div class="english-tit"><img class="tit-i" src="../../assets/research/研究列表标题.png" alt=""></div>
          </div>
          
        </div>
        <div class="color-t"><img src="../../assets/research/矩形.png" alt=""></div>
      </div>
      <div class="bigimg"><span></span></div>
    </div>
    <div class="content">
        <div class="nav">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item>首页</el-breadcrumb-item>
            <el-breadcrumb-item>
              <a>研究</a>
            </el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="router">
          <div class="tab">
            <el-tabs :tab-position="position" @tab-click="handleClick">
              <el-tab-pane label="科研奖项"></el-tab-pane>
              <el-tab-pane label="学术论文"></el-tab-pane>
              <el-tab-pane label="授权专利"></el-tab-pane>
              <el-tab-pane label="研究成果"></el-tab-pane>
              <el-tab-pane label="出版制作"></el-tab-pane>
              <!-- <el-tab-pane label="仪器设备"></el-tab-pane> -->
            </el-tabs>
          </div>
          <div class="text-content">
            <router-view></router-view>
          </div>
        </div>

    </div>
    <Footer class="foot"></Footer>
  </div>
</template>

<script>
import Footer from '../../components/footer'
export default {
  name: "research",
  components: {
    Footer
  },
  data() {
    return {
      position: 'right'
    };
  },
  mounted () {
    var medias = window.matchMedia('(max-width: 750px)')
    console.log(medias.matches)
    if (medias.matches) {
      this.position = 'top'
    }
  },
  methods: {
      handleClick (tab) {
        const id = tab.index
        if (id == 0) {
          this.$router.push('/research/awards')
        } else if (id == 1) {
          this.$router.push('/research/article')
        } else if (id == 2) {
          this.$router.push('/research/patent')
        } else if (id == 3) {
          this.$router.push('/research/achievement')
        } else if (id == 4) {
          this.$router.push('/research/publish')
        } else {
          this.$router.push('/research/equipment')
        }
      }
  },
};
</script>

<style scoped lang="less">
@Font: 50;
.footFlex{
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  .foot{
    margin-top: auto;
  }
}
.bg-img {
  display: flex;
  height: 340px;
}
.logoimg {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.logo-top {
  height: 300px;
  background-color: #0C31AE;
  padding: 20px 0 0 15vw;
  position: relative;
}
.english-tit {
  padding-top: 41px;
}
.j-img {
  position: absolute;
  bottom: -27px;
  right: 5%;
}
.logo-i {
  width: 162px;
  height: 45px;
  opacity: 0;
}


.color-t {
  display: flex;
  justify-content: flex-end;
  width: 400px;
  padding-left: 370px;
}
.bigimg {
  flex: 2;
  background: url(../../assets/research/头图.png);
  background-size: cover;
  position: relative;
  span {
      position: absolute;
      bottom: 0;
      width: 40px;
      height: 40px;
      background-color:#16E4DC;
  }
}
.content {
  width: 1280px;
  margin: 0 auto;
}
.nav {
  padding: 40px 0 32px 0;
}
/deep/ .el-tabs__nav-wrap::after {
  display: block;
}
/deep/ .el-tabs--right .el-tabs__header.is-right {
  margin: 0;
  float: none;
}
/deep/ .el-tabs__item {
  font-weight: 600;
  font-size: 22px;
  color: #000;
}
/deep/ .el-tabs__active-bar {
  width: 4px !important;
  background-color: #0C31AE;
}
/deep/ .el-tabs__item.is-active {
  color: #0C31AE;
}
.router {
  display: flex;
}
.tab {
  flex: 1;
}
.text-content {
  flex: 3;
}


// 媒体
@media screen and (max-width: 750px) {
  /deep/ .el-tabs__nav-scroll {
    overflow-x: auto !important;
    font-size: 32rem / @Font;
  }
  .el-tabs__nav-scroll::-webkit-scrollbar {
    display: none !important;
  }
  /deep/ .el-tabs__active-bar {
    width: 64rem / @Font !important;
    height: 6rem / @Font;
  }
  /deep/ .el-tabs__active-bar{
    left: 30rem / @Font;
  }
  /deep/ .el-tabs--top .el-tabs__item.is-top:nth-child(2){
    padding: 0 0.8rem !important;
  }
  /deep/ .el-tabs__nav-wrap.is-scrollable{
    padding: 0;
  }
  /deep/ .el-tabs__nav {
    padding: 28rem / @Font 0;
    background-color: #F1F0F6;
  }
  /deep/ .el-tabs__item {
    font-size: 32rem / @Font;
    height: 45rem / @Font;
    line-height: 45rem / @Font;
    padding: 0 40rem / @Font;
  }
  .nav {
    display: none;
  }
  .bg-img  {
    display: block;
    height: 100%;
  }
  .content {
    width: auto;
    margin: 0;
    padding-bottom: 56rem / @Font;
  }
  .logo-top {
    height: 280rem / @Font;
    padding: 15rem / @Font 0 30rem / @Font 50rem / @Font;
  }
  .logo-i {
    width: 215rem / @Font;
    height: 60rem / @Font;
    // opacity: 1;
  }
  .tit-i {
    width: 291rem / @Font;
    height: 168rem / @Font;
  }
  .english-tit {
    padding-top: 40rem / @Font;
  }
  .j-img {
    display: none;
  }
  .color-t {
    display: none;
  }
  .bigimg {
    height: 320rem / @Font;
    display: none;
  }
  .router {
    display: block;
  }
  .text-content {
    margin: 56rem / @Font 46rem / @Font 0;
  }
}
</style>
